/**
 * Query parameter shapes.
 *
 * These serialise directly to FastAPI query strings, so the mock adapter and
 * the eventual HTTP calls accept identical inputs.
 */
import type { TurnkeyStatus } from "@/types";

export interface ProjectQuery {
  q?: string;
  type?: string;
  city?: string;
  year?: string;
  service?: string;
  sort?: "newest" | "oldest" | "featured" | "az";
}

export interface TurnkeyQuery {
  q?: string;
  status?: TurnkeyStatus[];
  propertyType?: string[];
  city?: string[];
  configuration?: string[];
  amenities?: string[];
  possession?: string[];
  stage?: string[];
  maxPrice?: number;
  minArea?: number;
  sort?: "status" | "price-asc" | "price-desc" | "possession" | "az";
}

export interface PlanQuery {
  q?: string;
  category?: string;
  infrastructure?: string[];
  flooring?: string[];
  formats?: string[];
  style?: string[];
  bedrooms?: string[];
  floors?: string[];
  minArea?: number;
  maxArea?: number;
  maxPrice?: number;
  ownedIds?: string[];
  onlyOwned?: boolean;
  sort?: "popular" | "newest" | "price-asc" | "price-desc" | "area-asc" | "area-desc" | "rating";
}

export interface BlogQuery {
  q?: string;
  category?: string;
  sort?: "newest" | "oldest" | "shortest";
}

export interface JobQuery {
  q?: string;
  department?: string;
  location?: string;
  type?: string;
}

export interface SearchQuery {
  q?: string;
  kind?: string;
  sort?: "relevance" | "az" | "type";
}

/** Drops empty values so cache keys stay stable and URLs stay short. */
export function toParams<T extends object>(query: T): Record<string, string | string[]> {
  const out: Record<string, string | string[]> = {};
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === "" || value === false) continue;
    if (Array.isArray(value)) {
      if (value.length === 0) continue;
      out[key] = value.map(String);
    } else {
      out[key] = String(value);
    }
  }
  return out;
}
